import React from "react";
import "./SuccessBuy.css";
import { Link } from "react-router-dom";

function SuccesBuy() {
  return (
    <div>
      <div className="container" style={{ backgroundColor: "#F9F9F9" }}>
        <div className="container wow fadeInUp align-items-center mt-4 mb-5">
          <h2 className="mt-3">Sweet!</h2>
          <p className="mt-4">Your order has been approved.</p>
          <p>
            You'll be receiving the finest chocolate at your home between 3-5
            days.
          </p>
          <p>Thanks for buying at LaderHack.</p>
          <Link to="/">
            <button id="homeBtn">Back to Home</button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default SuccesBuy;
